import "./variant-radios";
import { updateFlavorSlider } from "./flavorSliderUtils.js";

export { BackInStockNotice } from "./backInStock.js";
export { OhiWidget } from "./ohiWidget.js";
export { ProductGallery } from "./productGallery.js";
export { QuantitySelector } from "./quantitySelector.js";
export { CampaignHelloBar } from "./campaignHelloBar.js";
export { CampaignFamilySlider } from "./campaignFamilySlider.js";
export { CampaignQuoteSlider } from "./campaignQuoteSlider.js";
export { ComboBox } from "./comboBox.js";

document.addEventListener('DOMContentLoaded', () => {
  updateFlavorSlider();
});


